import React from "react";
import Button from "../../../../atoms/Button";
import { getDocumentTypeFromRefId, DocumentType } from "../../../../../utils/documentTypeUtils";
import { COLOR_SYSTEM } from "../../../../design/design-system";

interface ReferenceButtonProps {
  refId: string;
  children: React.ReactNode;
  onReferenceClick?: (referenceId: string) => void;
  isAdmin?: boolean;
}

// 문서 타입별 색상 및 스타일 정의
const getButtonStyleByType = (docType: DocumentType) => {
  switch (docType) {
    case "BEERS2023":
      return {
        color: COLOR_SYSTEM.get("Orange")?.[500],
      };
    case "SPSTv3":
    case "SPSTv2":
      return {
        color: COLOR_SYSTEM.get("Green")?.[500],
      };
    case "CCMM":
    case "LCMM":
      return {
        color: COLOR_SYSTEM.get("Purple")?.[500],
      };
    case "POLY":
      return {
        color: COLOR_SYSTEM.get("Brown")?.[500],
      };
    case "KABS":
      return {
        color: COLOR_SYSTEM.get("Skyblue")?.[500],
      };
    case "KDGERI":
      return {
        color: COLOR_SYSTEM.get("Yellow")?.[500],
      };
    case "HFF":
      return {
        color: COLOR_SYSTEM.get("Red")?.[500],
      };
    case "LABEL":
    default:
      return {
        color: COLOR_SYSTEM.get("Blue")?.[500],
      };
  }
};

const ReferenceButton: React.FC<ReferenceButtonProps> = ({
  refId,
  children,
  onReferenceClick,
  isAdmin = false,
}) => {
  const docType = getDocumentTypeFromRefId(refId);
  const buttonStyle = getButtonStyleByType(docType);

  const handleContextMenu = (e: React.MouseEvent) => {
    if (!isAdmin) return;
    
    e.preventDefault();
    const originalId = refId.startsWith("medication-")
      ? `의약품: ${refId.replace("medication-", "")}`
      : refId.startsWith("SPSTv3_") ||
        refId.startsWith("STOP_") ||
        refId.startsWith("START_")
      ? `⑦${refId}`
      : `#${refId}`;

    const result = window.confirm(
      `원본 참고문헌 ID:\n${originalId}\n\n클립보드에 복사하시겠습니까?`
    );

    if (result) {
      navigator.clipboard
        .writeText(originalId)
        .then(() => {
          alert("클립보드에 복사되었습니다!");
        })
        .catch(() => {
          alert("복사에 실패했습니다.");
        });
    }
  };

  return (
    <span 
      onContextMenu={handleContextMenu}
      data-reference-id={refId}
      data-reference-link="true"
    >
      <Button
        type="Text"
        size="Small"
        color="Primary"
        variant="Ghost"
        onClick={() => onReferenceClick && onReferenceClick(refId)}
        data-reference-id={refId}
        data-reference-link="true"
        style={{
          margin: "0 1px",
          padding: "0 2px",
          fontSize: 12,
          color: buttonStyle.color,
          borderRadius: "2px",
          fontWeight: 500,
          maxHeight: "1.6rem",
          lineHeight: "1.2",
        }}
      >
        {children}
      </Button>
    </span>
  );
};

export default ReferenceButton;